/* @desc 课程分类列表
 * @Author: guoguo;
 * @Date: 2019-03-26 09:47:00;
 * @Last Modified by:   guoguo;
 * @Last Modified time: 2019-03-26 09:47:00;
 */

import Loadable from 'react-loadable';
import React, { Component } from 'react';
// import Handle from '../../component/CourseClassify/ClassifyList'
const Handle = Loadable({
  loader: () => import('../../component/CourseClassify/ClassifyList'),
  loading: () => null,
})

export default class ClassifyList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <Handle from="index" />
  }
}
